module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-50-active-bft-ce29d2eeb3631873dca225364244926c.png";